export default __webpack_public_path__ + "static/media/logo-light-renaissance.91ba902c.svg";